export const selectInvestMaster = (investmentMasterData, currentGameMonth) => {
    let selectedInvestMasterArr = [];
    for (let i=0; i<investmentMasterData.length; i++){
        let investMasterValid = true;
        if (investmentMasterData[i].investmentType === "bond"){
            let termMonths = 0;
            if (investmentMasterData[i].bondInfo.termUnit === "Months"){
                termMonths = +investmentMasterData[i].bondInfo.term;
            }else{
                termMonths = (+investmentMasterData[i].bondInfo.term * 12).toFixed(0);
            }
            const startMonth = +investmentMasterData[i].bondInfo.startMonthNbr;
            const endMonth = startMonth + +termMonths;
            if (+currentGameMonth >= startMonth && +currentGameMonth < +endMonth){
                //  game month is within the date range
            }else{       
                investMasterValid = false;
            }
        }
        if (investMasterValid === true){
            selectedInvestMasterArr.push(investmentMasterData[i]);
        }
    }
    return selectedInvestMasterArr;
}

export default selectInvestMaster;
